let storeContent = utils.generateStore({
	assessmentFields: [],
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async fetchAssessments(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'assesment',
						action: 'get',
						data: {},
					},
					'/client',
				);

				ctx.commit(
					'assessmentFields',
					res.result.assesments.client_self_assesments,
				);
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
	},
};
